// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__F6MJB","calendarButtons":"ClockData_calendarButtons__3Ot1C"};